import React from "react";
import { signOutUseCase } from "../../usecases/user";
import BasePage from "../../base/BasePage";
import { indexedDBService } from "../../dexie/indexedDBService";

class AccessDeniedPage extends BasePage {
  constructor(props) {
    super(props);
    this.signOutUseCase = signOutUseCase();
  }

  async onClickLogout() {
    try {
      await indexedDBService.clear();
    } catch (error) {
      console.error("Failed to clear IndexedDB:", error);
    }
    await this.signOutUseCase.execute();
    this.navigateTo("/signin");
  }

  render() {
    return (
      <div className="vh-100 d-flex align-items-center">
        <div className="container text-center w-50">
          <i className="bi bi-lock fs-1" />
          &nbsp;<h1 className="d-inline">403</h1>
          <h1>Access Denied</h1>
          <p>You don't have permission to access this page</p>
          <button onClick={this.onClickLogout.bind(this)}>Log out</button>
        </div>
      </div>
    );
  }
}

export default AccessDeniedPage;
